import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { createI18n } from "vue-i18n-composable";
import { importAllNamed } from "@Shared/utils/utils";
const en = importAllNamed == null ? void 0 : importAllNamed(require.context("./en", true, /.json$/), false);
const fr = importAllNamed == null ? void 0 : importAllNamed(require.context("./fr", true, /.json$/), false);
export const messages = {
  "en-CA": en,
  "fr-CA": fr
};
export default createI18n({
  locale: "en-CA",
  fallbackLocale: "en-CA",
  silentFallbackWarn: !process.env.DEVELOPMENT,
  silentTranslationWarn: !process.env.DEVELOPMENT,
  messages,
  postTranslation(translated) {
    if (typeof translated === "string" && _includesInstanceProperty(translated).call(translated, "[FR]")) {
      return translated.replace(/\[FR\]/g, "");
    }
    return translated;
  }
});